export default function datesAreInSameYear(date1, date2) {
	return date1.getFullYear() === date2.getFullYear();
}